export const LiveChatMessages = {
    CreateLiveChatAppNavigation: 'CREATE_LIVE_CHAT_APP_NAVIGATION',
};
